export default {
  安全提示: "安全提示",
  安全提示内容: "为保障账户安全，建议您立即修改密码。",
  去修改密码: "去修改密码",
};
